export default "__VITE_ASSET__DwSLQhqk__"